// extracted by mini-css-extract-plugin
module.exports = {"attention":"AttentionVisual_attention_2j_Gk","first_list":"AttentionVisual_first_list_3UQTG"};